import React, { useState, useEffect } from "react";
import { Alert, Table, Button, Container, Card,Modal,Row,Col, Form, Pagination, Spinner } from 'react-bootstrap';
import UserService from "../services/user.service";  // Update API service to handle t_customer data

function loginPasswordError(password, confirm, required) {
  if (!password && !confirm) return required ? 'Passwort ist ein Pflichtfeld' : '';
  if (!password || password.length < 10) return 'Das Passwort muss mindestens 10 Zeichen haben';
  if (!/[A-Za-z]/.test(password) || !/\d/.test(password)) return 'Das Passwort braucht mindestens einen Buchstaben und eine Zahl';
  if (password !== confirm) return 'Die Passwörter stimmen nicht überein';
  return '';
}

const CustomerManagerADM = () => {
  const [customers, setCustomers] = useState([]);
  const [formData, setFormData] = useState({
    custumer_company_name: '',
    custumer_contact_firstname: '',
    custumer_contact_lastname: '',
    custumer_contact_mobile: '',
    custumer_postal_code: '',
    custumer_city: '',
    custumer_city_add: '',
    custumer_str: '',
    custumer_street_number: '',
    custumer_street_add: '',
    custumer_tax_number: '',
    custumer_tax_id: '',
    custumer_company_email: '',
    login_password: '',
    login_password_confirm: '',
    privacy_consent: false,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('custumer_company_name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [loginNotice, setLoginNotice] = useState('');

  useEffect(() => {
    loadCustomers();
  }, [currentPage, searchTerm, sortField, sortOrder]);

  const loadCustomers = async () => {
    setApiErrors('');
    setLoading(true);
    try {
      const response = await UserService.getAllCustomersADMP({
        page: currentPage,
        search: searchTerm,
        sort: sortField,
        order: sortOrder
      });
      setCustomers(response.data.customers);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      setApiErrors('Kunden konnten nicht geladen werden');
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to the first page when searching
  };

  const handleSortChange = (field) => {
    const newSortOrder = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(newSortOrder);
  };

  const handleCreateClick = () => {
    setFormData({
      custumer_company_name: '',
      custumer_contact_firstname: '',
      custumer_contact_lastname: '',
      custumer_contact_mobile: '',
      custumer_postal_code: '',
      custumer_city: '',
      custumer_city_add: '',
      custumer_str: '',
      custumer_street_number: '',
      custumer_street_add: '',
      custumer_tax_number: '',
      custumer_tax_id: '',
      custumer_company_email: '',
      login_password: '',
      login_password_confirm: '',
      privacy_consent: false,
    });
    setApiErrors('');
    setErrors({});
    setShowCreateModal(true);
  };

  const handleEditClick = (customer) => {
    setSelectedCustomer(customer);
    setFormData({
      custumer_company_name: customer.custumer_company_name,
      custumer_contact_firstname: customer.custumer_contact_firstname,
      custumer_contact_lastname: customer.custumer_contact_lastname,
      custumer_contact_mobile: customer.custumer_contact_mobile,
      custumer_postal_code: customer.custumer_postal_code,
      custumer_city: customer.custumer_city,
      custumer_city_add: customer.custumer_city_add,
      custumer_str: customer.custumer_str,
      custumer_street_number: customer.custumer_street_number,
      custumer_street_add: customer.custumer_street_add,
      custumer_tax_number: customer.custumer_tax_number,
      custumer_tax_id: customer.custumer_tax_id,
      custumer_company_email: customer.custumer_company_email,
      login_password: '',
      login_password_confirm: '',
      privacy_consent: false,
    });
    setApiErrors('');
    setLoginNotice('');
    setErrors({});
    setShowEditModal(true);
  };

  const handleResetCustomerPassword = async () => {
    if (!selectedCustomer?.customer_id) return;
    const email = formData.custumer_company_email || selectedCustomer.custumer_company_email;
    const definedPassword = formData.login_password || formData.login_password_confirm;
    const passwordError = loginPasswordError(formData.login_password, formData.login_password_confirm, false);
    if (passwordError) {
      setErrors((prev) => ({ ...prev, login_password: passwordError }));
      setApiErrors(passwordError);
      return;
    }
    if (definedPassword && !formData.privacy_consent) {
      setApiErrors('Bitte die Einwilligung bestätigen, bevor ein selbst festgelegtes Passwort gespeichert wird.');
      return;
    }
    const question = definedPassword
      ? `Das festgelegte Passwort für ${email} speichern und per E-Mail mitteilen?`
      : `Neues Passwort an ${email} senden? Der Kunde erhält die Zugangsdaten per E-Mail.`;
    if (!window.confirm(question)) return;
    setApiErrors('');
    setLoginNotice('');
    setLoading(true);
    try {
      const response = await UserService.resetCustomerPassword(selectedCustomer.customer_id, {
        login_password: formData.login_password || '',
        login_password_confirm: formData.login_password_confirm || '',
        privacy_consent: !!formData.privacy_consent,
      });
      setLoginNotice(response.data?.message || 'Das neue Passwort wurde per E-Mail gesendet. Bitte auch den Spam-Ordner prüfen.');
      setFormData((prev) => ({ ...prev, login_password: '', login_password_confirm: '' }));
    } catch (error) {
      setApiErrors(error.response?.data?.message || 'Das Passwort konnte nicht gesendet werden.');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = async (customer_id) => {
    if (window.confirm('Are you sure you want to delete this customer?')) {
      try {
        await UserService.deleteCustomerBoard(customer_id);
        loadCustomers(); // Reload customers after successful deletion
      } catch (error) {
        setApiErrors('Kunde konnte nicht gelöscht werden');
      }
    }
  };

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({ ...formData, [e.target.name]: value });
    validateForm(e.target.name, e.target.value);
  };

  const validateForm = () => {
    const newErrors = {};
  
    // Validate company_name
    if (!formData.custumer_company_name.trim()) {
      newErrors.custumer_company_name = 'Firmenname ist ein Pflichtfeld';
    }
  
    // Validate company_email
    if (!formData.custumer_company_email.trim()) {
      newErrors.custumer_company_email = 'Firmen-E-Mail ist ein Pflichtfeld';
    } else if (!/\S+@\S+\.\S+/.test(formData.custumer_company_email)) {
      newErrors.custumer_company_email = 'Firmen-E-Mail muss eine gültige E-Mail-Adresse sein';
    }
  
    // Validate contact_first_name
    if (!formData.custumer_contact_firstname.trim()) {
      newErrors.custumer_contact_firstname = 'Vorname ist ein Pflichtfeld';
    }
  
    // Validate contact_last_name
    if (!formData.custumer_contact_lastname.trim()) {
      newErrors.custumer_contact_lastname = 'Nachname ist ein Pflichtfeld';
    }
  
    // Validate mobile number
    if (!formData.custumer_contact_mobile.trim()) {
      newErrors.custumer_contact_mobile = 'Mobilnummer ist ein Pflichtfeld';
    }else if (!/^(00\d{2,3}|0\d{4,}|(\+49)?\d{3,})\d{6,}$/g.test(formData.custumer_contact_mobile)) {
      newErrors.custumer_contact_mobile = 'Mobilnummer muss eine gültige Telefonnummer sein';
    }
  
    
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  

  

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setApiErrors('');
    setErrors({});
    if (!validateForm()) {
      setLoading(false);
      setApiErrors('Bitte korrigieren Sie die markierten Felder.');
      return;
    }
    const passwordError = loginPasswordError(formData.login_password, formData.login_password_confirm, true);
    if (passwordError) {
      setLoading(false);
      setErrors((prev) => ({ ...prev, login_password: passwordError }));
      setApiErrors(passwordError);
      return;
    }
    if (!formData.privacy_consent) {
      setLoading(false);
      setErrors((prev) => ({ ...prev, privacy_consent: 'Bitte die Einwilligung bestätigen.' }));
      setApiErrors('Bitte die Einwilligung zur Verarbeitung der Zugangsdaten bestätigen.');
      return;
    }

    try {
      const response = await UserService.createCustomerBoard(formData);
      if (response.data?.existing) {
        setApiErrors('Diese E-Mail gehört bereits zu einem Kunden.');
        return;
      }
      if (response.data?.email_sent === false) {
        setLoginNotice(response.data.message);
      } else {
        setLoginNotice('Kunde angelegt. Die Zugangsdaten wurden per E-Mail gesendet. Bitte auch den Spam-Ordner prüfen.');
      }
      setShowCreateModal(false);
      loadCustomers();
    } catch (error) {
      setApiErrors('Kunde konnte nicht angelegt werden');
    } finally {
      setLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    console.log('Halloo2 ');
    e.preventDefault();
    setLoading(true);
    setApiErrors('');
    setErrors({});

    if (!validateForm()) {
      setLoading(false);
      setApiErrors('Bitte korrigieren Sie die markierten Felder.');
      return;
    }

    try {
      const { login_password, login_password_confirm, privacy_consent, ...customerData } = formData;
      await UserService.updateCustomerBoard(selectedCustomer.customer_id, customerData);
      setShowEditModal(false);
      loadCustomers();
    } catch (error) {
      console.log('Halloo3 ',error);
      setApiErrors('Kunde konnte nicht gespeichert werden');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <h1>Kundenverwaltung</h1>
      {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
      {loginNotice && !showEditModal && !showCreateModal && <Alert variant="success">{loginNotice}</Alert>}
      <Button onClick={handleCreateClick}>Kunde anlegen</Button>
      <Form.Group controlId="searchCustomer">
        <Form.Label>Kunde suchen</Form.Label>
        <Form.Control
          type="text"
          placeholder="Nach Firmenname suchen"
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </Form.Group>
      {loading && <Spinner animation="border" />}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th onClick={() => handleSortChange('customer_id')}>ID</th>
            <th onClick={() => handleSortChange('custumer_company_name')}>Firmenname</th>
            <th onClick={() => handleSortChange('custumer_company_email')}>E-Mail</th>
            <th>Ansprechpartner</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {customers.map(customer => (
            <tr key={customer.customer_id}>
              <td>{customer.customer_id}</td>
              <td>{customer.custumer_company_name}</td>
              <td>{customer.custumer_company_email}</td>
              <td>{`${customer.custumer_contact_firstname} ${customer.custumer_contact_lastname}`}</td>
              <td>
                <Button variant="warning" onClick={() => handleEditClick(customer)}>Bearbeiten</Button>{' '}
                <Button variant="danger" onClick={() => handleDeleteClick(customer.customer_id)}>Löschen</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination>
        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item key={index} active={index + 1 === currentPage} onClick={() => setCurrentPage(index + 1)}>
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>
{/* Create Modal */}
<Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} size="xl">
  <Modal.Header closeButton>
    <Modal.Title>Kunde anlegen</Modal.Title>
  </Modal.Header>
  {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
  <Modal.Body>
    <Form onSubmit={handleCreateSubmit}>
      <Row>
        {/* Firmeninformationen Card */}
        <Col md={12} lg={6} className="mb-3">
          <Card>
            <Card.Header className="bg-primary text-white" as="h5">Firmeninformationen</Card.Header>
            <Card.Body>
              <Form.Group controlId="custumer_company_name">
                <Form.Label>Firmenname</Form.Label>
                <Form.Control
                  type="text"
                  name="custumer_company_name"
                  value={formData.custumer_company_name}
                  onChange={handleChange}
                  onBlur={handleChange}
                  isInvalid={!!errors.custumer_company_name}
                />
                <Form.Control.Feedback type="invalid">{errors.custumer_company_name}</Form.Control.Feedback>
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group controlId="custumer_company_email">
                    <Form.Label>Firmen-E-Mail</Form.Label>
                    <Form.Control
                      type="email"
                      name="custumer_company_email"
                      value={formData.custumer_company_email}
                      onChange={handleChange}
                      onBlur={handleChange}
                      isInvalid={!!errors.custumer_company_email}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_company_email}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="custumer_tax_number">
                    <Form.Label>Steuernummer</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_tax_number"
                      value={formData.custumer_tax_number}
                      onChange={handleChange}
                      onBlur={handleChange}
                      isInvalid={!!errors.custumer_tax_number}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_tax_number}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group controlId="custumer_tax_id">
                    <Form.Label>Umsatzsteuer-ID</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_tax_id"
                      value={formData.custumer_tax_id}
                      onChange={handleChange}
                      onBlur={handleChange}
                      isInvalid={!!errors.custumer_tax_id}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_tax_id}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="custumer_contact_firstname">
                    <Form.Label>Vorname</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_contact_firstname"
                      value={formData.custumer_contact_firstname}
                      onChange={handleChange}
                      onBlur={handleChange}
                      isInvalid={!!errors.custumer_contact_firstname}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_contact_firstname}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group controlId="custumer_contact_lastname">
                    <Form.Label>Nachname</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_contact_lastname"
                      value={formData.custumer_contact_lastname}
                      onChange={handleChange}
                      onBlur={handleChange}
                      isInvalid={!!errors.custumer_contact_lastname}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_contact_lastname}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="custumer_contact_mobile">
                    <Form.Label>Mobilnummer</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_contact_mobile"
                      value={formData.custumer_contact_mobile}
                      onChange={handleChange}
                      onBlur={handleChange}
                      isInvalid={!!errors.custumer_contact_mobile}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_contact_mobile}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        {/* Adresse Card */}
        <Col md={12} lg={6}>
          <Card>
            <Card.Header className="bg-info text-white" as="h5">Adresse</Card.Header>
            <Card.Body>
              <Row>
                <Col md={6}>
                  <Form.Group controlId="custumer_postal_code">
                    <Form.Label>Postleitzahl</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_postal_code"
                      value={formData.custumer_postal_code}
                      onChange={handleChange}
                      onBlur={handleChange}
                      isInvalid={!!errors.custumer_postal_code}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_postal_code}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="custumer_city">
                    <Form.Label>Stadt</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_city"
                      value={formData.custumer_city}
                      onChange={handleChange}
                      onBlur={handleChange}
                      isInvalid={!!errors.custumer_city}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_city}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group controlId="custumer_city_add">
                    <Form.Label>Ort Zusatz</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_city_add"
                      value={formData.custumer_city_add}
                      onChange={handleChange}
                      onBlur={handleChange}
                      isInvalid={!!errors.custumer_city_add}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_city_add}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="custumer_str">
                    <Form.Label>Straße</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_str"
                      value={formData.custumer_str}
                      onChange={handleChange}
                      onBlur={handleChange}
                      isInvalid={!!errors.custumer_str}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_str}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group controlId="custumer_street_number">
                    <Form.Label>Hausnummer</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_street_number"
                      value={formData.custumer_street_number}
                      onChange={handleChange}
                      onBlur={handleChange}
                      isInvalid={!!errors.custumer_street_number}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_street_number}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="custumer_street_add">
                    <Form.Label>Adresszusatz</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_street_add"
                      value={formData.custumer_street_add}
                      onChange={handleChange}
                      onBlur={handleChange}
                      isInvalid={!!errors.custumer_street_add}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_street_add}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card className="mb-3">
        <Card.Header className="text-white" as="h5" style={{ backgroundColor: '#1f6f78' }}>Login</Card.Header>
        <Card.Body>
          <p className="mb-3">
            Der Benutzername ist die Firmen-E-Mail. Das Passwort wird nur verschlüsselt gespeichert und einmalig per E-Mail mitgeteilt. Es wird nicht in der Datenbank im Klartext abgelegt.
          </p>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group controlId="create_login_password">
                <Form.Label>Passwort</Form.Label>
                <Form.Control
                  type="password"
                  name="login_password"
                  autoComplete="new-password"
                  value={formData.login_password}
                  onChange={handleChange}
                  isInvalid={!!errors.login_password}
                />
                <Form.Control.Feedback type="invalid">{errors.login_password}</Form.Control.Feedback>
                <Form.Text>Mindestens 10 Zeichen, davon ein Buchstabe und eine Zahl.</Form.Text>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group controlId="create_login_password_confirm">
                <Form.Label>Passwort wiederholen</Form.Label>
                <Form.Control
                  type="password"
                  name="login_password_confirm"
                  autoComplete="new-password"
                  value={formData.login_password_confirm}
                  onChange={handleChange}
                  isInvalid={!!errors.login_password}
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group controlId="create_privacy_consent">
            <Form.Check
              type="checkbox"
              name="privacy_consent"
              checked={!!formData.privacy_consent}
              onChange={handleChange}
              isInvalid={!!errors.privacy_consent}
              label={
                <span>
                  Der Kunde wurde informiert und stimmt zu, dass die E-Mail-Adresse als Benutzername und das Passwort ausschließlich für die Anmeldung verarbeitet werden. Es gilt die{' '}
                  <a href="https://www.myn.club/datenschutz" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a>.
                </span>
              }
            />
            {errors.privacy_consent && <div className="text-danger small mt-1">{errors.privacy_consent}</div>}
          </Form.Group>
        </Card.Body>
      </Card>

      {/* Submit Button */}
      <Button variant="primary" type="submit" disabled={loading} style={{ minHeight: 44 }}>
        {loading ? 'Wird angelegt...' : 'Anlegen'}
      </Button>
    </Form>
  </Modal.Body>
</Modal>






 {/* Edit Modal */}
<Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="xl">
  <Modal.Header closeButton>
    <Modal.Title>Kunde bearbeiten</Modal.Title>
  </Modal.Header>
  {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
  <Modal.Body>
    <Form onSubmit={handleEditSubmit}>
      <Row>
        {/* Firmeninformationen Card */}
        <Col md={12} lg={6} className="mb-3">
          <Card>
            <Card.Header className="bg-primary text-white" as="h5">Firmeninformationen</Card.Header>
            <Card.Body>
              <Form.Group controlId="custumer_company_name">
                <Form.Label>Firmenname</Form.Label>
                <Form.Control
                  type="text"
                  name="custumer_company_name"
                  value={formData.custumer_company_name}
                  onChange={handleChange}
                  isInvalid={!!errors.custumer_company_name}
                />
                <Form.Control.Feedback type="invalid">{errors.custumer_company_name}</Form.Control.Feedback>
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group controlId="custumer_company_email">
                    <Form.Label>Firmen-E-Mail</Form.Label>
                    <Form.Control
                      type="email"
                      name="custumer_company_email"
                      value={formData.custumer_company_email}
                      onChange={handleChange}
                      isInvalid={!!errors.custumer_company_email}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_company_email}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="custumer_tax_number">
                    <Form.Label>Steuernummer</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_tax_number"
                      value={formData.custumer_tax_number}
                      onChange={handleChange}
                      isInvalid={!!errors.custumer_tax_number}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_tax_number}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group controlId="custumer_tax_id">
                    <Form.Label>Umsatzsteuer-ID</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_tax_id"
                      value={formData.custumer_tax_id}
                      onChange={handleChange}
                      isInvalid={!!errors.custumer_tax_id}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_tax_id}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="custumer_contact_firstname">
                    <Form.Label>Vorname</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_contact_firstname"
                      value={formData.custumer_contact_firstname}
                      onChange={handleChange}
                      isInvalid={!!errors.custumer_contact_firstname}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_contact_firstname}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group controlId="custumer_contact_lastname">
                    <Form.Label>Nachname</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_contact_lastname"
                      value={formData.custumer_contact_lastname}
                      onChange={handleChange}
                      isInvalid={!!errors.custumer_contact_lastname}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_contact_lastname}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="custumer_contact_mobile">
                    <Form.Label>Mobilnummer</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_contact_mobile"
                      value={formData.custumer_contact_mobile}
                      onChange={handleChange}
                      isInvalid={!!errors.custumer_contact_mobile}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_contact_mobile}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        {/* Adresse Card */}
        <Col md={12} lg={6}>
          <Card>
            <Card.Header className="bg-info text-white" as="h5">Adresse</Card.Header>
            <Card.Body>
              <Row>
                <Col md={6}>
                  <Form.Group controlId="custumer_postal_code">
                    <Form.Label>Postleitzahl</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_postal_code"
                      value={formData.custumer_postal_code}
                      onChange={handleChange}
                      isInvalid={!!errors.custumer_postal_code}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_postal_code}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="custumer_city">
                    <Form.Label>Stadt</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_city"
                      value={formData.custumer_city}
                      onChange={handleChange}
                      isInvalid={!!errors.custumer_city}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_city}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group controlId="custumer_city_add">
                    <Form.Label>Ort Zusatz</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_city_add"
                      value={formData.custumer_city_add}
                      onChange={handleChange}
                      isInvalid={!!errors.custumer_city_add}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_city_add}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="custumer_str">
                    <Form.Label>Straße</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_str"
                      value={formData.custumer_str}
                      onChange={handleChange}
                      isInvalid={!!errors.custumer_str}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_str}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group controlId="custumer_street_number">
                    <Form.Label>Hausnummer</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_street_number"
                      value={formData.custumer_street_number}
                      onChange={handleChange}
                      isInvalid={!!errors.custumer_street_number}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_street_number}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="custumer_street_add">
                    <Form.Label>Adresszusatz</Form.Label>
                    <Form.Control
                      type="text"
                      name="custumer_street_add"
                      value={formData.custumer_street_add}
                      onChange={handleChange}
                      isInvalid={!!errors.custumer_street_add}
                    />
                    <Form.Control.Feedback type="invalid">{errors.custumer_street_add}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card className="mb-3">
        <Card.Header className="text-white" as="h5" style={{ backgroundColor: '#1f6f78' }}>Login</Card.Header>
        <Card.Body>
          <p className="mb-3">
            Der Benutzername ist die Firmen-E-Mail. Ein selbst festgelegtes Passwort können Sie unten eintragen. Sonst wird ein neues Passwort erzeugt. In beiden Fällen geht eine E-Mail an den Kunden. Bitte auch den Spam-Ordner prüfen.
          </p>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group controlId="customer_login_username">
                <Form.Label>Benutzername</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.custumer_company_email || ''}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group controlId="edit_login_password">
                <Form.Label>Neues Passwort</Form.Label>
                <Form.Control
                  type="password"
                  name="login_password"
                  autoComplete="new-password"
                  value={formData.login_password}
                  onChange={handleChange}
                  isInvalid={!!errors.login_password}
                  placeholder="Leer lassen für ein automatisch erzeugtes Passwort"
                />
                <Form.Control.Feedback type="invalid">{errors.login_password}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group controlId="edit_login_password_confirm">
                <Form.Label>Neues Passwort wiederholen</Form.Label>
                <Form.Control
                  type="password"
                  name="login_password_confirm"
                  autoComplete="new-password"
                  value={formData.login_password_confirm}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group controlId="edit_privacy_consent" className="mb-3">
            <Form.Check
              type="checkbox"
              name="privacy_consent"
              checked={!!formData.privacy_consent}
              onChange={handleChange}
              label={
                <span>
                  Der Kunde stimmt zu, dass die Zugangsdaten nur für die Anmeldung verarbeitet werden. Es gilt die{' '}
                  <a href="https://www.myn.club/datenschutz" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a>.
                </span>
              }
            />
          </Form.Group>
          <Button
            type="button"
            variant="outline-primary"
            onClick={handleResetCustomerPassword}
            disabled={loading || !selectedCustomer}
            style={{ minHeight: 44 }}
          >
            Passwort speichern und per E-Mail senden
          </Button>
          {loginNotice && <Alert variant="success" className="mt-3 mb-0">{loginNotice}</Alert>}
        </Card.Body>
      </Card>

      {/* Submit Button */}
      <Button variant="primary" type="submit" disabled={loading} style={{ minHeight: 44 }}>
        {loading ? 'Wird gespeichert...' : 'Speichern'}
      </Button>
    </Form>
  </Modal.Body>
</Modal>

    </Container>
  );
};

export default CustomerManagerADM;
